import { useEffect, useRef, useState } from 'react';
import withDashboardLayout from '../../hoc/withDashboardLayout';
import { Button, Dropdown, Modal, Select, message } from 'antd';
import { CaretDownFilled, LeftOutlined, RightOutlined } from '@ant-design/icons';
// import DeleteIcon from '../../../src/assets/delete-icon.png';
import IconShow from '../../assets/show-icon_eyes.png';
import MaterialTable from 'material-table';
import SendIcon from '../../assets/send-icon.png';
import tableIcons from '../../utils/tableIcons';
import TicketDetails from '../../components/admin/TicketDetails';
import CustomSelect from '../../components/ui/CustomSelect';
import SortIcon from '../../assets/sort.svg';
import UserImage from '../../assets/user.svg';
import CalenderImg from '../../assets/calendar.svg';
import Loader from '../../components/shared/Loader';
import { GetSupportTickets, UpdateSupportTicket } from '../../utils/api';
import dayjs from 'dayjs';



const SupportTickets = () => {
    const tableRef = useRef(null);
    const [modalData, setModalData] = useState({ visible: false, selectedStatus: '', ticket: '', action: '' });
    const [infoModalData, setInfoModalData] = useState({ visible: false, data: null });
    const [ticketDrawerData, setTicketDrawerData] = useState({ visible: false, data: null });
    const [loading, setLoading] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [query, setQuery] = useState({
        page: 0,
        pageSize: 10,
        search: '',
        orderField: '',
        orderDirection: '',
        customFilter: ''
    });

    const dropdownItems = [
        {
            label: 'Open',
            key: 'open',
            disabled: false,
        },
        {
            label: 'In Progress',
            key: 'inProgress',
            disabled: false,
        },
        {
            label: 'Resolved',
            key: 'resolved',
            disabled: false,
        },
    ];

    const columns = [
        {
            title: 'Ticket Id',
            field: 'id',
            sorting: true,
            cellStyle: { width: '10%' },
        },
        {
            title: 'Username',
            field: 'username',
            sorting: false,
            cellStyle: { width: '20%' },
            render: (record) => {
                return (
                    <span>{record?.user?.email}</span>
                )
            },
        },
        {
            title: 'Date',
            field: 'created_at',
            sorting: false,
            cellStyle: { width: '15%' },
            render: (record) => {
                return (
                    <span className='w-80%'>{dayjs(record.created_at).format('DD MMM YYYY, h:mma')}</span>
                )
            },
        },
        {
            title: 'Subject',
            field: 'subject',
            sorting: false,
            cellStyle: { width: '15%' },
            render: (record) => {
                return (
                    <span className='w-[60%]' title={record.subject}>
                        {record.subject.length > 40
                            ? record.subject.slice(0, 40) + "..."
                            : record.subject}
                    </span>
                )
            },
        },
        {
            title: 'Last updated on',
            field: 'updated_at',
            sorting: false,
            cellStyle: { width: '18%' },
            render: (record) => {
                return (
                    <span>{dayjs(record.updated_at).format('DD MMM YYYY, h:mma')}</span>
                )
            },
        },
        {
            title: 'Status',
            field: 'statusType',
            sorting: false,
            align: 'right',
            cellStyle: { width: '13%' },
            render: (record) => {
                let updatedItems = dropdownItems.filter((item) => {
                    return item.key !== record.statusType;
                });
                return (
                    <div className='cursor-pointer'>
                        <Dropdown
                            menu={{ items: updatedItems, onClick: (e) => handleActionModalOpen('changeStatus', e?.key, record) }}
                            trigger={['click']}>
                            <div className='flex items-center justify-end gap-x-1'>
                                <span className={`capitalize ${record.statusType === 'open' ? 'text-[green]' : record.statusType === 'resolved' ? 'text-yellow-500' : 'text-orange'}`}>
                                    {record.statusType === 'inProgress' ? 'In progress' : record.statusType}
                                </span>
                                <button className='text-[10px]' onClick={(e) => e.preventDefault()}>
                                    <CaretDownFilled />
                                </button>
                            </div>
                        </Dropdown>
                    </div>
                )
            },
        },
        {
            title: 'Action',
            sorting: false,
            align: 'center',
            cellStyle: { width: '9%' },
            render: (record) => {
                return (
                    <div className='flex items-center justify-center gap-x-3' >
                        <span className='cursor-pointer' >
                            <img alt='show-icon' src={IconShow} width={18} onClick={() => handleInfoModal(record)} />
                        </span>
                        {/* <span className='cursor-pointer' onClick={() => handleActionModalOpen('delete', '', record)}>
                            <img alt='show-icon' src={DeleteIcon} width={16} />
                        </span> */}
                        <span onClick={(e) => handleSendEmail(e, record)} className='cursor-pointer' >
                            <img alt='send-icon' src={SendIcon} width={18} />
                        </span>
                    </div >
                )
            },
        },
    ];






    const handleInfoModal = (data) => {
        setInfoModalData({ visible: true, data: data });
    }

    const fetchData = async (dataquery) => {

        setLoading(true);

        let params = '';

        if (dataquery?.search) {
            params += `search=${dataquery.search}`;
        }

        if (dataquery?.orderBy) {
            params += `&sort=${dataquery?.orderBy.field}&order=${dataquery?.orderDirection}`;
        }

        params += `&pageNo=${dataquery?.page + 1}`;

        params += `&limit=${dataquery?.pageSize}`;

        if (query.customFilter) {
            params += `&statusType=${query.customFilter}`;
        }

        const response = await GetSupportTickets(params);

        setLoading(false);

        return {
            data: response?.items,
            page: dataquery?.page,
            totalCount: response?.totalRecords
        };
    };

    const handleSortChange = (option) => {
        setQuery((prev) => ({ ...prev, customFilter: option }));
    }

    const handleSendEmail = (e, record) => {
        e.stopPropagation();
        setTicketDrawerData({ visible: true, data: record });
    }

    const handleActionModalOpen = (action, status, ticket) => {
        if (action === 'changeStatus') {
            setModalData({ visible: true, ticket: ticket, selectedStatus: status, action: action });
        } else if (action === 'delete') {
            setModalData({ visible: true, ticket: ticket, selectedStatus: '', action: action });
        }
    };

    const handleModalCancel = () => {
        setModalData({ visible: false, selectedStatus: '', ticket: '' });
    }

    const handleChangeStatusOk = async () => {
        if (modalData.action === 'changeStatus') {
            try {
                setBtnLoading(true);
                const res = await UpdateSupportTicket({ statusType: modalData?.selectedStatus }, modalData?.ticket?.id);
                setBtnLoading(false);
                if (res?.isSuccess) {
                    message.success('Ticket status updated successfully');
                    setModalData({ selectedStatus: null, user: null, id: null, visible: false, action: null });
                    tableRef.current.onQueryChange();
                }
            } catch (error) {
                setBtnLoading(false);
                message.error('Error in updating status, Try again later');
            }
        }
    }

    const handleDeleteOk = async () => {
        if (modalData.action === 'delete') {
            // try {
            //     setBtnLoading(true);
            //     const res = await DeleteClient({ statusType: modalData?.selectedStatus }, modalData?.id);
            //     setBtnLoading(false);
            //     if (res?.isSuccess) {
            //         message.success('Client Deleted successfully');
            //         setModalData({ id: null, visible: false, selectedStatus: null, user: null, action: null });
            //         tableRef.current.onQueryChange();
            //     }
            // } catch (error) {
            //     setBtnLoading(false);
            //     message.error('Error in deletion, Try again later');
            // }
        }
    }




    const overlayContainer = {
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 999,
    }

    useEffect(() => {
        tableRef.current.onQueryChange(query);
    }, [query.customFilter]);

    return (
        <div className='w-full h-full'>
            <div className='w-[95%] mx-auto'>

                {/* Support Tickets Header */}
                <div className='w-full py-4'>
                    <h2 className='font-semibold text-lg title text-[#000000]'>Support Tickets</h2>
                </div>

                {/* Support Tickets */}
                <div className='search-custom-space main-scroll w-full min-h-[calc(100vh-170px)] h-[380px] overflow-scroll flex flex-col gap-y-5 box-shadow rounded-2xl relative'>

                    <div className={`custom-sortby absolute z-50 left-[284px] top-[19px] ${loading && 'opacity-50'}`}>
                        <CustomSelect prefixIcon={SortIcon} width='w-32' value={query.customFilter} onChange={(val) => handleSortChange(val)}>
                            <Select.Option value=''>All</Select.Option>
                            <Select.Option value='open'>Open</Select.Option>
                            <Select.Option value='inProgress'>In Progress</Select.Option>
                            <Select.Option value='resolved'>Resolved</Select.Option>
                        </CustomSelect>
                    </div>

                    <MaterialTable
                        title="Support Tickets"
                        tableRef={tableRef}
                        columns={columns}
                        icons={tableIcons}
                        page={query.page}
                        options={{
                            showTitle: false,
                            draggable: false,
                            paging: true,
                            sorting: true,
                            pageSize: query.pageSize,
                            pageSizeOptions: [10, 25, 50, 100],
                            debounceInterval: 700,
                            padding: 'dense',
                            paginationType: 'stepped',
                            searchFieldVariant: 'outlined',
                            searchFieldAlignment: 'left'
                        }}
                        onChangeRowsPerPage={(pageSize => {
                            setQuery(prev => ({ ...prev, pageSize: Number(pageSize) }));
                        })}
                        onChangePage={(page => setQuery(prev => ({ ...prev, page: Number(page) })))}
                        data={query => fetchData(query)}
                        components={{
                            Pagination: (props) => {
                                const { page, rowsPerPage, count, onChangePage, onChangeRowsPerPage } = props;
                                return (
                                    <div className="box-shadow-pagination text-sm" style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 20px', marginTop: '20px' }}>
                                        <div>
                                            <div className='bottom-pagination-text'>
                                                <button className='disabled:opacity-50' onClick={(e) => onChangePage(e, page - 1)} disabled={page === 0}><LeftOutlined /></button>
                                                <span style={{ margin: '0 10px' }}>{page + 1} of {Math.ceil(count / rowsPerPage)}</span>
                                                <button className='disabled:opacity-50' onClick={(e) => onChangePage(e, page + 1)} disabled={page === Math.ceil(count / rowsPerPage) - 1 || tableRef.current?.dataManager?.data?.length === 0}><RightOutlined /></button>
                                            </div>
                                        </div>
                                        <div style={{ position: 'absolute', right: '25px' }} >
                                            <span style={{ margin: '0 10px' }}>Items per page:</span>
                                            <select className='pagination-select'
                                                disabled={tableRef.current?.dataManager?.data?.length === 0}
                                                value={rowsPerPage}
                                                onChange={(e) => {
                                                    onChangeRowsPerPage(e, e.target.value)
                                                }}>
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                        </div>
                                    </div>
                                );
                            },
                            OverlayLoading: (props) => {
                                return (
                                    <div style={overlayContainer}>
                                        <Loader />
                                    </div>
                                )
                            }
                        }}
                    />

                    <Modal
                        centered
                        title='Support Ticket Details'
                        open={infoModalData.visible}
                        closable={false}
                        footer={
                            <button className="ant-btn ant-btn-primary text-white text-[14px] h-[32px] py-1 px-4 rounded-[6px]" onClick={() => setInfoModalData({ visible: false, data: null })}>
                                OK
                            </button>
                        }>

                        {/* Ticket InforMation */}
                        <section className='flex pt-2 flex-col gap-y-2'>
                            <div className='pb-2 '>
                                <span className={`text-xs capitalize font-medium pt-1 pb-[6px] px-4 rounded-md border ${infoModalData?.data?.statusType === 'open' ? 'text-[green] border-[green]' : infoModalData?.data?.statusType === 'resolved' ? 'text-yellow-500 border-yellow-500' : 'text-orange border-orange'}`}>{infoModalData?.data?.statusType === 'inProgress' ? 'in progress' : infoModalData?.data?.statusType}</span>
                            </div>
                            <div className=''>
                                <span className='text-xs font-medium'>{infoModalData?.data?.subject}</span>
                                <p className='text-xs text-lightGray 2xl:text-sm'>{infoModalData?.data?.message}</p>
                            </div>
                            <div className='flex items-start justify-between pt-3'>
                                <div className='flex items-center gap-x-1'>
                                    <img src={UserImage} alt="user" width={12} />
                                    <span className='text-xs font-semibold 2xl:text-sm'>{infoModalData?.data?.user?.email}</span>
                                </div>
                                <div className='flex items-center gap-x-1'>
                                    <img src={CalenderImg} alt="calender" width={12} />
                                    <span className='text-xs font-semibold 2xl:text-sm'>{dayjs(infoModalData?.data?.created_at).format('DD MMM YYYY, h:mma')}</span>
                                </div>
                            </div>
                        </section>
                    </Modal>


                    <Modal
                        centered
                        title={modalData.action === 'delete' ? 'Confirm Delete' : 'Confirm Status Change'}
                        open={modalData.visible}
                        onCancel={handleModalCancel}
                        footer={<div>
                            <Button onClick={handleModalCancel}>Cancel</Button>
                            <Button type='primary' className='text-white' onClick={modalData.action === 'delete' ? handleDeleteOk : handleChangeStatusOk}>
                                Ok
                                {btnLoading && <span className='loader ml-2 align-middle mb-1'></span>}
                            </Button>
                        </div>}
                    >
                        {
                            modalData.action === 'changeStatus' ? `Are you sure you want to change the status of ticket having id ${modalData?.ticket?.id} to ${modalData.selectedStatus === 'inProgress' ? 'in progress' : modalData.selectedStatus}?` : `Are you sure you want to delete ${modalData?.ticket?.ticketId}?`
                        }
                    </Modal>

                    <TicketDetails ticketDrawerData={ticketDrawerData} setTicketDrawerData={setTicketDrawerData} />

                </div>
            </div>
        </div>
    )
}

export default withDashboardLayout(SupportTickets);